import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-text-image',
  templateUrl: './text-image.component.html',
  styleUrls: ['./text-image.component.scss'],
})
export class TextImageComponent  implements OnInit {

  tinyMceKey = environment.tinyMceKey;
  @Input() text: string = '';
  @Input() image: any;
  @Input() left: boolean = false;
  fileUploadInputs = ['image'];
  @Input() blocIndex: number = 0;

  @Output() inputChange = new EventEmitter<{
    text: string;
    image: string;
    left: boolean;
  }>();
  constructor() {
  }

  ngOnInit() {
    const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    if (!formattedActualite.articleBlocks) {
      return;
    }
    const block = formattedActualite.articleBlocks.find((block: any) => block.type === 1);
    if (block) {
      this.text = block.content.text;
      this.left = block.content.left;
      this.onEditorChange();
    }
  }

  onToggleChange(){
    this.inputChange.emit({
      text: this.text,
      image: this.image,
      left: this.left,
    });
  }

  onEditorChange() {
    this.inputChange.emit({
      text: this.text,
      image: this.image,
      left: this.left,
    });
  }

  onInputChange(event: any) {
    this.image = event.files[0];

    this.inputChange.emit({
      text: this.text,
      image: this.image,
      left: this.left,
    });
  }
}
